var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.84,
    height: 176.881,
    viewBox: "0 0 120.84 176.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M59.63-66.873V-32.1c0,40.706-23.368,60.383-41.468,75.58C10.683,49.78,4.121,55.282.76,61.12a1.678,1.678,0,0,1-.661.693,1.621,1.621,0,0,1-2.179-.6c-3.393-5.833-9.982-11.335-17.5-17.631C-37.741,28.356-61.21,8.68-61.21-32.1V-66.873a1.61,1.61,0,0,1,1.582-1.614c38.7,0,57.288-33.329,57.549-33.787a1.687,1.687,0,0,1,.6-.591,1.6,1.6,0,0,1,2.173.591c.032.1,18.654,33.787,57.352,33.787A1.61,1.61,0,0,1,59.63-66.873ZM56.429-32.1V-65.323C23.047-66.085,4.323-90.806-.689-98.449-5.7-90.806-24.456-66.085-58.014-65.323V-32.1c0,39.321,22.814,58.438,40.482,73.241C-10.676,46.882-4.577,52.022-.689,57.493,3.13,51.99,9.267,46.85,16.122,41.044,33.726,26.279,56.429,7.162,56.429-32.1Z",
    transform: "translate(61.21 103.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M-38.372-71.264a1.617,1.617,0,0,1,1.619,1.614,1.611,1.611,0,0,1-1.619,1.582h-8.272a1.61,1.61,0,0,1-1.614-1.582,1.616,1.616,0,0,1,1.614-1.614Z",
    transform: "translate(117.248 240.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M-30.171-68.852a1.562,1.562,0,0,1-1.582,1.582H-49.485a1.582,1.582,0,0,1-1.582-1.582,1.61,1.61,0,0,1,1.582-1.614h17.732A1.589,1.589,0,0,1-30.171-68.852Z",
    transform: "translate(105.095 244.151)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(34.213 46.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M-46.231-73.457a.787.787,0,0,0-.788.788.787.787,0,0,0,.788.788,10.2,10.2,0,0,0,10.216-9.726.791.791,0,0,0-.751-.826.81.81,0,0,0-.826.751A8.625,8.625,0,0,1-46.231-73.457Z",
    transform: "translate(88.396 146.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M-44.455-80.165a.787.787,0,0,0,.788-.788V-82.52a.787.787,0,0,0-.788-.788.787.787,0,0,0-.788.788v1.566A.787.787,0,0,0-44.455-80.165Z",
    transform: "translate(96.08 142.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M-44.455-81.063a.79.79,0,0,0,.788-.788v-1.566a.787.787,0,0,0-.788-.788.787.787,0,0,0-.788.788v1.566A.79.79,0,0,0-44.455-81.063Z",
    transform: "translate(96.08 138.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M-44.455-81.962a.787.787,0,0,0,.788-.788v-1.566a.787.787,0,0,0-.788-.788.787.787,0,0,0-.788.788v1.566A.787.787,0,0,0-44.455-81.962Z",
    transform: "translate(96.08 134.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M-47.095-23.4h31.906a7.106,7.106,0,0,0,7.1-7.1V-87.275a6.668,6.668,0,0,0-.527-2.658,7.042,7.042,0,0,0-6.568-4.437H-47.095a7.107,7.107,0,0,0-7.1,7.1v56.782A7.09,7.09,0,0,0-47.095-23.4Zm-5.524-63.877a5.527,5.527,0,0,1,5.524-5.518h31.906a5.487,5.487,0,0,1,5.114,3.468,5.18,5.18,0,0,1,.4,2.051v56.782a5.526,5.526,0,0,1-5.518,5.518H-47.095a5.514,5.514,0,0,1-5.524-5.518Z",
    transform: "translate(57.348 94.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M-49.363-34.533h21.94a.793.793,0,0,0,.788-.788.79.79,0,0,0-.788-.788h-21.94a2.371,2.371,0,0,1-2.365-2.37V-88.945a2.371,2.371,0,0,1,2.365-2.37h2.525a.787.787,0,0,0,.788-.788.79.79,0,0,0-.788-.788h-2.525A3.948,3.948,0,0,0-53.3-88.945v50.464A3.948,3.948,0,0,0-49.363-34.533Z",
    transform: "translate(61.199 100.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M-50.785-91.315H-28.12a2.371,2.371,0,0,1,2.365,2.37v50.464a2.371,2.371,0,0,1-2.365,2.37h-3.265a.787.787,0,0,0-.788.788.79.79,0,0,0,.788.788h3.265a3.948,3.948,0,0,0,3.942-3.947V-88.945a3.948,3.948,0,0,0-3.942-3.947H-50.785a.79.79,0,0,0-.788.788A.787.787,0,0,0-50.785-91.315Z",
    transform: "translate(68.693 100.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M-50.1-92.054h9.247a.787.787,0,0,0,.788-.788.787.787,0,0,0-.788-.788H-50.1a.79.79,0,0,0-.788.788A.79.79,0,0,0-50.1-92.054Z",
    transform: "translate(71.674 97.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M-51.769-80.96a3.635,3.635,0,0,0,3.627,3.627,3.636,3.636,0,0,0,3.633-3.627,3.637,3.637,0,0,0-3.633-3.633A3.636,3.636,0,0,0-51.769-80.96Zm5.684,0a2.056,2.056,0,0,1-2.056,2.051,2.055,2.055,0,0,1-2.051-2.051,2.056,2.056,0,0,1,2.051-2.056A2.057,2.057,0,0,1-46.085-80.96Z",
    transform: "translate(67.845 136.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M-45.7-84.593A3.637,3.637,0,0,0-49.33-80.96,3.636,3.636,0,0,0-45.7-77.333,3.632,3.632,0,0,0-42.07-80.96,3.633,3.633,0,0,0-45.7-84.593Zm0,5.684a2.056,2.056,0,0,1-2.056-2.051A2.057,2.057,0,0,1-45.7-83.016a2.056,2.056,0,0,1,2.051,2.056A2.055,2.055,0,0,1-45.7-78.909Z",
    transform: "translate(78.397 136.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M-46.766-79.367a.79.79,0,0,0,.788-.788v-2.9a10.874,10.874,0,0,0-.682-3.809.786.786,0,0,0-1.017-.463.791.791,0,0,0-.463,1.012,9.267,9.267,0,0,1,.586,3.26v2.9A.787.787,0,0,0-46.766-79.367Z",
    transform: "translate(83.334 124.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M-36.5-76.941a9.742,9.742,0,0,1,3.409,2.86.79.79,0,0,0,1.1.16.785.785,0,0,0,.16-1.1,11.258,11.258,0,0,0-3.414-3.031,7.552,7.552,0,0,0,2.029-5.124,7.6,7.6,0,0,0-7.59-7.59,7.6,7.6,0,0,0-7.59,7.59,7.535,7.535,0,0,0,2.035,5.13A11.167,11.167,0,0,0-51.964-68.4v2.9a.79.79,0,0,0,.788.788.79.79,0,0,0,.788-.788v-2.9A9.592,9.592,0,0,1-45.1-76.941a7.526,7.526,0,0,0,4.3,1.348A7.543,7.543,0,0,0-36.5-76.941Zm-4.3-12.251a6.021,6.021,0,0,1,6.014,6.014A6.02,6.02,0,0,1-40.8-77.17a6.015,6.015,0,0,1-6.008-6.008A6.016,6.016,0,0,1-40.8-89.192Z",
    transform: "translate(67.001 109.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M-54-87.11a.79.79,0,0,0,.788-.788v-1.566A.787.787,0,0,0-54-90.253a.787.787,0,0,0-.788.788V-87.9A.79.79,0,0,0-54-87.11Z",
    transform: "translate(54.787 112.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M-54-88.009a.787.787,0,0,0,.788-.788v-1.566A.787.787,0,0,0-54-91.152a.787.787,0,0,0-.788.788V-88.8A.787.787,0,0,0-54-88.009Z",
    transform: "translate(54.787 108.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M-54-88.907a.79.79,0,0,0,.788-.788v-1.566A.787.787,0,0,0-54-92.05a.787.787,0,0,0-.788.788V-89.7A.79.79,0,0,0-54-88.907Z",
    transform: "translate(54.787 104.408)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkImg5);
export default __webpack_public_path__ + "static/media/work-img5.05903ab950dddd1b7e7fa2361f10b531.svg";
export { ForwardRef as ReactComponent };